import { SIMPLIFIED_HEADER_URLS } from '~app/modules/generic/constants';
import { FLYOUT_RELOAD_EVENT_TYPE } from '~app/modules/account/constants/flyout.constant';

export namespace AccountFlyoutUtils {
  export const refreshFlyout = (accountId?: string) => {
    const reloadEvent = new Event(FLYOUT_RELOAD_EVENT_TYPE, { bubbles:true, cancelable:true });
    // @ts-ignore
    reloadEvent.forceRefresh = 1;
    if (accountId) {
      // @ts-ignore
      reloadEvent.accountId = accountId;
    }
    document.querySelector('cms-user-profile')?.dispatchEvent(reloadEvent);
  };

  export const isForceRefreshRequired = (url) => {
    return SIMPLIFIED_HEADER_URLS.some((path) => url.startsWith(path));
  };
}
